 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		3: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		3: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"46985a3037a348020be947d1b2e0e919fd3d177f","5":"component---src-pages-404-jsx","6":"component---src-pages-index-en-jsx","7":"component---src-pages-index-it-jsx","8":"component---src-pages-risultati-ricerca-en-jsx","9":"component---src-pages-risultati-ricerca-it-jsx","10":"component---src-pages-rss-en-jsx","11":"component---src-pages-rss-it-jsx","12":"component---src-pages-sitemap-en-jsx","13":"component---src-pages-sitemap-it-jsx","14":"component---src-templates-approfondimento-template-en-jsx","15":"component---src-templates-approfondimento-template-it-jsx","16":"component---src-templates-bando-di-gara-template-en-jsx","17":"component---src-templates-bando-di-gara-template-it-jsx","18":"component---src-templates-comunicato-stampa-template-en-jsx","19":"component---src-templates-comunicato-stampa-template-it-jsx","20":"component---src-templates-elenchi-elenco-approfondimenti-en-jsx","21":"component---src-templates-elenchi-elenco-approfondimenti-it-jsx","22":"component---src-templates-elenchi-elenco-attualita-en-jsx","23":"component---src-templates-elenchi-elenco-attualita-it-jsx","24":"component---src-templates-elenchi-elenco-bandi-di-gara-e-contratti-en-jsx","25":"component---src-templates-elenchi-elenco-bandi-di-gara-e-contratti-it-jsx","26":"component---src-templates-elenchi-elenco-foto-video-en-jsx","27":"component---src-templates-elenchi-elenco-foto-video-it-jsx","28":"component---src-templates-elenchi-elenco-normative-en-jsx","29":"component---src-templates-elenchi-elenco-normative-it-jsx","30":"component---src-templates-elenchi-elenco-podcast-en-jsx","31":"component---src-templates-elenchi-elenco-podcast-it-jsx","32":"component---src-templates-elenchi-elenco-pubblicazioni-en-jsx","33":"component---src-templates-elenchi-elenco-pubblicazioni-it-jsx","34":"component---src-templates-elenchi-glossario-en-jsx","35":"component---src-templates-elenchi-glossario-it-jsx","36":"component---src-templates-elenchi-timeline-en-jsx","37":"component---src-templates-elenchi-timeline-it-jsx","38":"component---src-templates-galleria-flickr-template-en-jsx","39":"component---src-templates-galleria-flickr-template-it-jsx","40":"component---src-templates-galleria-video-template-en-jsx","41":"component---src-templates-galleria-video-template-it-jsx","42":"component---src-templates-normativa-template-en-jsx","43":"component---src-templates-normativa-template-it-jsx","44":"component---src-templates-notizia-template-en-jsx","45":"component---src-templates-notizia-template-it-jsx","46":"component---src-templates-pagina-foglia-completa-template-en-jsx","47":"component---src-templates-pagina-foglia-completa-template-it-jsx","48":"component---src-templates-pubblicazione-template-en-jsx","49":"component---src-templates-pubblicazione-template-it-jsx","50":"component---src-templates-sezione-con-anticipazioni-template-en-jsx","51":"component---src-templates-sezione-con-anticipazioni-template-it-jsx","52":"component---src-templates-sezione-senza-anticipazioni-template-en-jsx","53":"component---src-templates-sezione-senza-anticipazioni-template-it-jsx"}[chunkId]||chunkId) + "-" + {"0":"c445f261e58dbc7bf2a0","1":"c2fe8482057191dca484","2":"b16a998974caf151afe1","5":"34b20aca36c733caf732","6":"e64d478b0e240b839e81","7":"d5d8e99e8a5f09626f3b","8":"1a282f3dc881ce1a54c8","9":"48a115784286bb6185da","10":"87a3b62c1a4399a061fa","11":"e20a68f5ffe6a275c343","12":"8b0660b4edc6b323a429","13":"64417e42c236c9ef19a7","14":"ece084fcd080980d0006","15":"8a7f12dcd5be547fdd8a","16":"2524ff52f152313dc3eb","17":"f174bbab7ee2fdbe51a6","18":"ea841246976f0c53f3e6","19":"09755c2da2c06154fb11","20":"ff628fb3f2b9a32ac38c","21":"866e4a59a3acf893913a","22":"3284f0c3997c09aacc5e","23":"272072f016ab5d145dea","24":"e1f56e45302f62259cea","25":"7dc921cb9d7570376a3b","26":"c985f1fe50b202e735ce","27":"f00881a8566b19208f6f","28":"e4b9f9251752e466b86d","29":"2436e0dcd5a5ac85cdd3","30":"76643f7334ed2bdc752a","31":"0fe7bf72f290fe03049b","32":"1eef847d2f72f1b42398","33":"aa761c07fe901987cc3e","34":"86d52258dea60734d42e","35":"3d6e9967900e462e973c","36":"f4648fae3aacc79189be","37":"482530627f5f5abd963b","38":"0a66055308a7287b8dd3","39":"1be9da9a2c1bd890a8ba","40":"bdf0db0caa5ccc0a0996","41":"d7661a2f00680b28a135","42":"03e640b696a4ca6f1009","43":"0b297ed47eff4e9b5736","44":"2d4771d838a5fbb447cd","45":"ec6f8d557f4dfc150ed2","46":"f33d87c26727a622e628","47":"ac23e49b6dca84907595","48":"0010fd767a7986687944","49":"34628177bf346d48f406","50":"c0545a39da33b8637468","51":"40eaed31b4aa03b45d92","52":"643d028cc47b08269a85","53":"89cfee4a37f64b5da3eb"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"46985a3037a348020be947d1b2e0e919fd3d177f","5":"component---src-pages-404-jsx","6":"component---src-pages-index-en-jsx","7":"component---src-pages-index-it-jsx","8":"component---src-pages-risultati-ricerca-en-jsx","9":"component---src-pages-risultati-ricerca-it-jsx","10":"component---src-pages-rss-en-jsx","11":"component---src-pages-rss-it-jsx","12":"component---src-pages-sitemap-en-jsx","13":"component---src-pages-sitemap-it-jsx","14":"component---src-templates-approfondimento-template-en-jsx","15":"component---src-templates-approfondimento-template-it-jsx","16":"component---src-templates-bando-di-gara-template-en-jsx","17":"component---src-templates-bando-di-gara-template-it-jsx","18":"component---src-templates-comunicato-stampa-template-en-jsx","19":"component---src-templates-comunicato-stampa-template-it-jsx","20":"component---src-templates-elenchi-elenco-approfondimenti-en-jsx","21":"component---src-templates-elenchi-elenco-approfondimenti-it-jsx","22":"component---src-templates-elenchi-elenco-attualita-en-jsx","23":"component---src-templates-elenchi-elenco-attualita-it-jsx","24":"component---src-templates-elenchi-elenco-bandi-di-gara-e-contratti-en-jsx","25":"component---src-templates-elenchi-elenco-bandi-di-gara-e-contratti-it-jsx","26":"component---src-templates-elenchi-elenco-foto-video-en-jsx","27":"component---src-templates-elenchi-elenco-foto-video-it-jsx","28":"component---src-templates-elenchi-elenco-normative-en-jsx","29":"component---src-templates-elenchi-elenco-normative-it-jsx","30":"component---src-templates-elenchi-elenco-podcast-en-jsx","31":"component---src-templates-elenchi-elenco-podcast-it-jsx","32":"component---src-templates-elenchi-elenco-pubblicazioni-en-jsx","33":"component---src-templates-elenchi-elenco-pubblicazioni-it-jsx","34":"component---src-templates-elenchi-glossario-en-jsx","35":"component---src-templates-elenchi-glossario-it-jsx","36":"component---src-templates-elenchi-timeline-en-jsx","37":"component---src-templates-elenchi-timeline-it-jsx","38":"component---src-templates-galleria-flickr-template-en-jsx","39":"component---src-templates-galleria-flickr-template-it-jsx","40":"component---src-templates-galleria-video-template-en-jsx","41":"component---src-templates-galleria-video-template-it-jsx","42":"component---src-templates-normativa-template-en-jsx","43":"component---src-templates-normativa-template-it-jsx","44":"component---src-templates-notizia-template-en-jsx","45":"component---src-templates-notizia-template-it-jsx","46":"component---src-templates-pagina-foglia-completa-template-en-jsx","47":"component---src-templates-pagina-foglia-completa-template-it-jsx","48":"component---src-templates-pubblicazione-template-en-jsx","49":"component---src-templates-pubblicazione-template-it-jsx","50":"component---src-templates-sezione-con-anticipazioni-template-en-jsx","51":"component---src-templates-sezione-con-anticipazioni-template-it-jsx","52":"component---src-templates-sezione-senza-anticipazioni-template-en-jsx","53":"component---src-templates-sezione-senza-anticipazioni-template-it-jsx"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"3ed2b765acfd065d290f","2":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
